import React from 'react'
import Modal from '../Modal'

const SelfReleaseModal = ({ open, handleClose }) => {
  const steps = [
    'Pay the amount due online in the next step',
    'Use key provided by BootVision after payment to release',
    'Expand green boot arm and remove',
    'Find the closest drop-off location and return the boot'
  ]

  return (
    <Modal open={open} noButtons onCancel={handleClose}>
      <div className="flex-1 flex flex-col justify-center items-center">
          <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
            <div className="font-bold text-center mb-4">Steps for self release</div>
            <div className="grid gap-4">
              {steps.map((value, i) => (
                <div className="flex" key={i}>
                  <div className="w-1 bg-primary-light rounded-full">&nbsp;</div>
                  <div className="py-1.5 pl-3 text-left">
                    <p className="text-gray-500"><span className=' font-semibold text-gray-800'>{i + 1}. </span>{value}</p>
                  </div>
                </div>
              ))}
            </div>
        </div>
      </div>
    </Modal>
  )
}

export default SelfReleaseModal
